import { forwardRef } from "react";

import dynamic from "next/dynamic";

import { LinkProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardLink = dynamic(() => import("./DashboardLinkSsr").then((mod) => mod.DashboardLinkSsr), {
  ssr: false,
});

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
export const DashboardLink = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <DynamicDashboardLink {...props} forwardedRef={ref} />
));

DashboardLink.displayName = "DashboardLink";
